<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Port Index</th>
        <th class="text-sm">Port Name</th>
        <th class="text-sm">Status</th>
        <th class="text-sm">Online ONU</th>
        <th class="text-sm">TX Power (dBm)</th>
        <th class="text-sm">Bias (mA)</th>
        <th class="text-sm">VCC (V)</th>
        <th class="text-sm">Max US (kbps)</th>
        <th class="text-sm">Actual US (kbps)</th>
        <th class="text-sm">Remain US (kbps)</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="10">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else>
        <tr
          v-for="(item, index) in onuInfo"
          :key="index"
        >
          <td class="text-sm">{{ item.port_index }}</td>
          <td class="text-sm">{{ item.port_name }}</td>
          <td class="text-sm">
            <span
              class="badge"
              :class="{
                'bg-success': item.status === 'UP',
                'bg-danger': item.status === 'DOWN',
                'bg-warning': item.status === 'RUNNING',
                'bg-secondary': !['UP','DOWN','RUNNING'].includes(item.status)
              }"
              style="text-transform: uppercase; color: rgb(255 249 249) !important;"
            >
              {{ item.status }}
            </span>
          </td>
          <td class="text-sm">{{ item.online_onu }}</td>
          <td class="text-sm">{{ item.txpower }}</td>
          <td class="text-sm">{{ item.bias }}</td>
          <td class="text-sm">{{ item.vcc }}</td>
          <td class="text-sm">{{ item.max_us_kbps }}</td>
          <td class="text-sm">{{ item.actual_us_kbps }}</td>
          <td class="text-sm">{{ item.remain_us_kbps }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'CdataOnuTable',
  components: {
    Skalaton
  },
  props: {
    onuInfo: Array,
    loading: Boolean
  }
}
</script>